/**
   * Orca validation, in order to know if the policy is basic,
   * based on its incident limit.
   * @param {*} incidentLimit incident limit of the Orca policy.
   */
export const isBasicOrcaPolicy = (
  incidentLimit,
) => parseInt(incidentLimit, 10) === 500;
